import React, { useMemo } from "react";
import { getFinanceCategoryColor, getFinanceCategoryIcon, FINANCE_ICONS } from "./financeConstants";
import { parseAmount } from "./financeUtils";

function FinanceMobileTransactionItem({ item, onEdit, readOnlyMode }) {
  return (
    <div
      onClick={() => !readOnlyMode && onEdit(item)}
      className={`bg-white p-3 rounded-2xl shadow-sm border border-gray-100 transition-all flex items-center gap-2.5 ${readOnlyMode ? "cursor-default" : "active:scale-[0.98] cursor-pointer"}`}
    >
      <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${getFinanceCategoryColor(item.category).replace("bg-", "bg-").replace("]", "]/10")}`}>
        <img src={getFinanceCategoryIcon(item.category)} className="w-5 h-5 object-contain" alt="" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 mb-0.5">
          <span className={`text-[10px] px-1.5 py-0.5 rounded-md font-bold text-white ${getFinanceCategoryColor(item.category)}`}>{item.category}</span>
          <h3 className="font-bold text-gray-800 text-[13px] truncate">{item.description}</h3>
        </div>
        <div className="text-[11px] text-gray-400 truncate">{item.department || "공통"}</div>
      </div>
      <div className={`font-black text-sm whitespace-nowrap ${item.type === "수입" ? "text-blue-500" : "text-rose-500"}`}>
        {item.type === "수입" ? "+" : "-"}
        {parseAmount(item.amount).toLocaleString()}
      </div>
    </div>
  );
}

export default function FinanceMobileTransactionSection({
  filteredTransactions,
  formatDateForGroup,
  onEdit,
  readOnlyMode,
}) {
  const groupedTransactions = useMemo(
    () => filteredTransactions.reduce((acc, item) => {
      const date = item.date;
      if (!acc[date]) acc[date] = [];
      acc[date].push(item);
      return acc;
    }, {}),
    [filteredTransactions]
  );

  if (filteredTransactions.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-10 text-gray-400 bg-white rounded-2xl border border-gray-100">
        <img src={FINANCE_ICONS.coin} width={42} className="opacity-30 mb-2 grayscale" alt="empty" />
        <p className="text-xs font-bold">내역이 없습니다</p>
      </div>
    );
  }

  return Object.entries(groupedTransactions)
    .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA))
    .map(([date, items]) => (
      <div key={date}>
        <div className="text-xs font-black text-[#354F38] mb-1.5 ml-1">
          {formatDateForGroup(date)}
        </div>
        <div className="space-y-2">
          {items.map((item) => (
            <FinanceMobileTransactionItem
              key={item.id}
              item={item}
              onEdit={onEdit}
              readOnlyMode={readOnlyMode}
            />
          ))}
        </div>
      </div>
    ));
}
